"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheUpdateMatrix = void 0;
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const noop = () => ({});
const cacheUpdateMatrix = exports.cacheUpdateMatrix = {
  authorizePasswordlessCustomer: noop,
  logoutCustomer: () => {
    return {
      remove: [{
        queryKey: ['/commerce-sdk-react']
      }]
    };
  },
  getAccessToken: noop,
  getSessionBridgeAccessToken: noop,
  getTrustedSystemAccessToken: noop,
  getTrustedAgentAccessToken: noop,
  resetPassword: noop,
  getPasswordLessAccessToken: noop,
  revokeToken: noop,
  introspectToken: noop
};